const gbpFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
});

export function formatGbp(amount) {
  const n = Number(amount);
  if (Number.isNaN(n)) return "—";
  return gbpFormatter.format(n);
}
